import ABCyaPhaser from "@abcya/abcya_phaser";
import FractionTile from "../ui/FractionTile";
import Fraction from "./Fraction";

export default class HowTo1 extends Phaser.GameObjects.Container {
    constructor(scene) {
        super(scene);

        this.workingWidth = null;
        this.workingHeight = null;

        this.inst1 = null;

        this.showContainer = null;

        this.fractionTile1 = null;
        this.fractionTile2 = null;
        this.lblPlus = null;
        this.lblEqual = null;
        this.lblOne = null;

        this.inst1 = ABCyaPhaser.Images.addImage(0, 0, "Label_Click", this);

        let den = Phaser.Math.Between(2, 9);
        let n1 = Phaser.Math.Between(1, den - 1);
        let n2 = den - n1;

        this.showContainer = this.scene.add.container();
        let test = new Fraction(n1, den);
        this.fractionTile1 = new FractionTile(this.scene);
        this.fractionTile1.setValue(test);
        this.fractionTile1.select();

        test = new Fraction(n2, den);
        this.fractionTile2 = new FractionTile(this.scene);
        this.fractionTile2.setValue(test);
        this.fractionTile2.select();

        this.lblPlus = ABCyaPhaser.Images.addImage(0, 0, "Plus", this.scene);
        this.lblEqual = ABCyaPhaser.Images.addImage(0, 0, "Equal", this.scene);
        this.lblOne = ABCyaPhaser.Images.addImage(0, 0, "One", this.scene);

        this.lblPlus.x = this.fractionTile1.workingWidth + 20;
        this.fractionTile2.x = this.lblPlus.x + this.lblPlus.width + 20;
        this.lblEqual.x = this.fractionTile2.x + this.fractionTile2.workingWidth + 20;
        this.lblOne.x = this.lblEqual.x + this.lblEqual.width + 20;

        this.lblPlus.y = this.fractionTile1.workingHeight / 2 - this.lblPlus.height / 2;
        this.lblEqual.y = this.fractionTile1.workingHeight / 2 - this.lblEqual.height / 2;
        this.lblOne.y = this.fractionTile1.workingHeight / 2 - this.lblOne.height / 2;

        this.showContainer.add([this.fractionTile1, this.fractionTile2, this.lblPlus, this.lblEqual, this.lblOne]);
        this.add(this.showContainer);

        this.showContainer.y = this.inst1.height + 50;
        this.showContainer.x = (this.inst1.width - this.lblOne.x + this.lblOne.width) / 2;

        this.workingWidth = this.inst1.width;
        this.workingHeight = this.showContainer.y + this.fractionTile1.workingHeight;
    }

    initAnimation() { }
}